<div class="cards-wrapper" [ngClass]="{'lg-width': callTypesInModule === 'CONVERSATIONAL' && !isMsgAdherence}">
  <div class="card-content" [ngClass]="{'lg-width': callTypesInModule === 'CONVERSATIONAL' && !isMsgAdherence}">
    <div class="title">{{ title }}</div>
    <div class="call-name">
      <img src="/assets/icons/phone-call-01.svg">
      <span *ngIf="(numberOfCalls ?? 0) > 1">
        {{ numberOfCalls }} {{ 'reporting.CALLS' | transloco }}
      </span>
      <span *ngIf="(numberOfCalls ?? 0) == 1">
        {{ callName }}
      </span>
    </div>
    <div class="question">{{ questionName }}</div>
  </div>
  <div *ngIf="barMode == 'percentage'" class="highest-percentage"
    [ngClass]="barType === 'highest' ? 'highest-percentage' : 'lowest-percentage'">
    <div class="percentage-number">
      {{percentage | number:'1.0-0'}}<span>%</span>
    </div>
    <div class="bar">
      <mat-progress-bar class="custom-progress-bar" mode="determinate" [value]="percentage"></mat-progress-bar>
      <p>{{barMsg}}</p>
    </div>

  </div>
  <div *ngIf="barMode == 'number'" [ngClass]="barType === 'highest' ? 'highest-bar-container' : 'lowest-bar-container'">
    <div class="score-container">
      <div class="achieved-score">
        {{ percentage || 0 | number : "1.1-1" }}
      </div>
      <div class="total-score">&nbsp;/&nbsp;{{ totalScore }}</div>
    </div>
    <div class="progress-bar" *ngIf="calculateProgress(percentage || '0', totalScore); let bar">
      <div class="segment" *ngFor="let i of [].constructor(totalScore); let index = index"
        [class.filled]="index < bar.filled">
        <div class="partial-fill" *ngIf="index === bar.filled && bar.partial > 0" [style.width.%]="bar.partial * 100">
        </div>
      </div>
    </div>
    <p>{{barMsg}}</p>
  </div>
  <div class="cta" (click)="openModal()">
    <div class="info-btn">
      {{ 'reporting.VIEW_INFO' | transloco }}
    </div>
    <img src="/assets/icons/arrow/arrow-narrow-right.svg">
  </div>
</div>